export function getNameInitials(fullName: string): string {
  if (!fullName) return '';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  } else {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
}
